import { userConstants } from './../constants/user.constants';

const initialState = {};

export function Loans(state = initialState, action) {
  switch (action.type) {
    case userConstants.LOANS_REQUEST:
      return {
        user: action.user,
        isLoading : true

      };
    case userConstants.LOANS_SUCCESS:
      const {res} = action
        
      return {
        res,
        isLoading : false
      };
    case userConstants.LOANS_FAILURE:
      return {
        isLoading : false
      };
    default:
      return state
  }
}